import { render } from "./BaseTabButton.vue?vue&type=template&id=35153ed9&scoped=true"
import script from "./BaseTabButton.vue?vue&type=script&lang=js"
export * from "./BaseTabButton.vue?vue&type=script&lang=js"

import "./BaseTabButton.vue?vue&type=style&index=0&id=35153ed9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35153ed9"]])

export default __exports__